import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';
import React from 'react';

import Header from './Header';

const Layout = (props) => {
  const contenuRef = React.createRef();
  const Component = props.component;
  const { route, wsStatus } = props;

  let theme = createMuiTheme({
    typography: {
      fontFamily: [
        'Gadugi',
        'sans-serif',
      ].join(','),
      fontWeightMedium: 500,
      h6: {
        fontSize: 25,
        marginLeft: 25,
      },
      caption: {
        fontSize: 10,
        marginLeft: 25,
        marginTop: 10
      },
      subtitle1: {
        fontSize: 12,
      },
    },
    palette: {
      primary: {
        main: '#0094ca'
      },
      secondary: {
        main: '#0094ca'
      },
      success: {
        main: '#a5c946'
      }
    }
  });

  return (
    <div id="layout">
      <MuiThemeProvider theme={theme}>
        <div>
          <div id="filtre-rose" />
          <Header
            logout={props.logout}
            wsStatus={wsStatus}
          />
          <div className="card-contenu" ref={contenuRef}>
            <Component
              title={props.title}
              contenu={props.contenu}
              route={route}
              contenuRef={contenuRef}
              params={props.params}
              wsStatus={wsStatus}
              // pushWs={pushWs}
              // setPushWs={setPushWs}
            />
          </div>
        </div>
      </MuiThemeProvider>
    </div>
  );
}

export default Layout;